export enum MembershipPlanSkuEnum {
  Camelot = 'Camelot',
  Lancelot = 'Lancelot',
  Excalibur = 'Excalibur',
  'King-Arthur' = 'King-Arthur',
}
